import axios from 'axios';

/*
*  This file contains all axios calls related to add to sequence operations
*/

export const mapCampaignInfoToCampaignList = async (data) => {
    return Object.entries(data).map((entry) => {
        return { value: entry[0], label: entry[1] };
    }).sort((prev, next) => prev.label.localeCompare(next.label));
};

export const getPublishedCampaigns = async () => {
    const { data } = await axios.get('/app/funnel/publishedCampaigns');

    return mapCampaignInfoToCampaignList(data);
};

export const getCampaignSequences = async (funnelId) => {
    const { data } = await axios.get(`/app/addToSequenceFunnel/getFlowsForFunnel?funnelId=${funnelId}`);

    return mapCampaignInfoToCampaignList(data);
};
